/** @format */

export const GET_USERS_COMPANY = 'GET_USERS_COMPANY'
export const GET_USERS_COMPANY_SUCCESS = 'POST_USER_SUCCESS'
export const GET_USERS_COMPANY_ERROR = 'POST_USER_ERROR'
